
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/topfoot.css'; 
import './assets/css/index.css'; 
import './assets/css/procommon.css';
import './assets/css/aside.css';
import "./assets/fonts/iconfont.css";
import $ from 'jquery';

import { Carousel, Slide } from 'vue-carousel'
Vue.component('carousel', Carousel)
Vue.component('slide', Slide)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$ = $;
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js